import React from "react";

export default function AuthorizedTeacher() {
  return (
    <div className="space-y-8">
      <section className="space-y-4">
        <h1 className="text-2xl font-semibold tracking-tight text-slate-900">Become an Authorized Teacher</h1>
        <p className="max-w-3xl text-sm leading-relaxed text-slate-700 sm:text-base">
          Experienced music educators may apply to become authorized teachers with Global Music Conservatory. Authorized teachers are recognised partners who are familiar with the syllabi, assessment criteria and administrative procedures of the conservatory.
        </p>
      </section>

      <section className="grid gap-6 rounded-2xl border border-slate-200 bg-white/80 p-5 shadow-sm backdrop-blur-xl sm:grid-cols-2 sm:p-6">
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Eligibility</h2>
          <ul className="space-y-1">
            <li>• Substantial experience in teaching the relevant instrument(s) or voice.</li>
            <li>• A record of preparing candidates for external examinations or equivalent assessments.</li>
            <li>• Commitment to professional conduct and adherence to examination regulations.</li>
          </ul>
        </div>
        <div className="space-y-3 text-sm text-slate-700">
          <h2 className="text-base font-semibold tracking-tight text-slate-900">Benefits</h2>
          <ul className="space-y-1">
            <li>• Access to detailed guidance on syllabus updates and assessment practices.</li>
            <li>• Priority communication regarding examination sessions and administrative timelines.</li>
            <li>• Eligibility to use the &quot;Authorized Teacher&quot; designation in communications with students and institutions.</li>
          </ul>
        </div>
      </section>

      <section className="space-y-3 text-sm text-slate-700">
        <h2 className="text-base font-semibold tracking-tight text-slate-900">Application process</h2>
        <p>
          Applications may be submitted by individual teachers or on behalf of institutions. Further information about documentation requirements and review procedures will be provided through the teacher portal.
        </p>
      </section>
    </div>
  );
}
